import type { ChatMessage } from "@/types";

type StreamPayload = Record<string, any>;

export function buildHistoryFromStreamPayload(
   payload: StreamPayload
): ChatMessage[] | undefined {
   return payload?.history?.map((msg: ChatMessage, index: number) => {
      const isLastMessage = index === payload.history.length - 1;
      return {
         ...msg,
         attachments: isLastMessage ? payload.attachments : msg.attachments || [],
         ...(isLastMessage &&
            msg.role === "assistant" &&
            payload?.placeholderRegistry && {
               placeholderRegistry: payload.placeholderRegistry
            }),
         ...(isLastMessage &&
            msg.role === "assistant" &&
            payload?.expandedQuery && {
               expandedQuery: payload.expandedQuery
            }),
         ...(isLastMessage &&
            msg.role === "assistant" &&
            Array.isArray(payload?.functionCallsUsed) && {
               metaData: payload.functionCallsUsed
            })
      } as ChatMessage;
   });
}

export function mergeFeedbackIntoHistory(
   updatedHistory: ChatMessage[],
   currentHistory: ChatMessage[]
): ChatMessage[] {
   const feedbackByMessageId = new Map<string, ChatMessage["feedback"]>();
   for (const msg of currentHistory) {
      if (msg.id && msg.feedback) {
         feedbackByMessageId.set(msg.id, msg.feedback);
      }
   }

   return updatedHistory.map((msg) => {
      if (msg.id && feedbackByMessageId.has(msg.id)) {
         return {
            ...msg,
            feedback: feedbackByMessageId.get(msg.id)
         };
      }
      return msg;
   });
}

export function findLastAssistantContent(history?: ChatMessage[]): string | undefined {
   return [...(history || [])].reverse().find((msg) => msg.role === "assistant")?.content;
}
